import { render, staticRenderFns } from "./ClienteCoordinate.vue?vue&type=template&id=38a24d4e"
import script from "./ClienteCoordinate.vue?vue&type=script&lang=js"
export * from "./ClienteCoordinate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports